import ChatBodyChats from "./ChatBodyChats";

export default ChatBodyChats;
